import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { VFC } from 'react';

import { ListingType } from '@/apis/aniftyBackend/mintAsks/interface';
import EthereumIcon from '@/icons/ethereum-icon.svg';

import CreationCardContent from '../CreationCardContent';
import styles from './CreationCard.module.scss';

type Props = {
  link: string;
  creationImageUrl: string;
  thumbnailUrl?: string;
  creationName: string;
  creatorName: string;
  creatorProfileImageUrl: string;
  price: string;
  size?: number;
  listingType: ListingType;
};

const CreationCard: VFC<Props> = ({
  link,
  creationImageUrl,
  thumbnailUrl,
  creationName,
  creatorName,
  creatorProfileImageUrl,
  price,
  size = 330,
  listingType,
}) => {
  const { t } = useTranslation();

  const currency = listingType === ListingType.Auction ? 'WETH' : 'ETH';

  return (
    <Link href={link}>
      <a
        className={classNames(styles.item, {
          [styles.auctionItem]: listingType === ListingType.Auction,
        })}
        target="_blank"
        rel="noreferrer"
      >
        <CreationCardContent
          creationImageUrl={creationImageUrl}
          thumbnailUrl={thumbnailUrl}
          creationName={creationName}
          creatorName={creatorName}
          creatorProfileImageUrl={creatorProfileImageUrl}
          size={size}
          isInverted={listingType === ListingType.Auction}
        />

        <div className={styles.saleInfo}>
          <div className={styles.sellingPriceLabel}>
            <p>{t('collectedCreation.sellingPrice')}</p>
          </div>

          <div className={styles.price}>
            <EthereumIcon />
            <p>
              {price} {currency}
            </p>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default CreationCard;
